<mat-spinner *ngIf="!tenantChecked" color="primary" diameter="30"></mat-spinner>

<span *ngIf="tenantChecked && tenant" class="logo-container" (click)="redirectHome()"
      [class.redirect-cursor]="redirectOnInteraction">
  <img src="{{tenant ? tenant.logoUrl : 'assets/logo-icon.png'}}" alt="logo" class="logo-icon" [class.vertical]="vertical"/>
  <span *ngIf="showText" class="logo-text mat-subheading-2" [class.vertical]="vertical">
    {{tenant ? tenant.name : 'QuizWin'}}
  </span>
</span>

<span *ngIf="tenantChecked && !tenant" class="logo-container" (click)="redirectHome()"
      [class.redirect-cursor]="redirectOnInteraction">
  <img [src]="vertical ? 'assets/logo-on-top.png' : 'assets/logo-line-in-middle.png'" alt="logo" class="logo" [class.vertical]="vertical"/>
</span>
